// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"98637d0c","977":"5c74407f"}[chunkId] + ".chunk.js";
};